var exports = {
  "zr": "IncomingCallUI.module__root___MmU1X3",
  "Nr": "IncomingCallUI.module__card___MmU1X3",
  "BU": "IncomingCallUI.module__dragHandle___MmU1X3",
  "IH": "IncomingCallUI.module__dragPill___MmU1X3",
  "t$": "IncomingCallUI.module__stack___MmU1X3",
  "wx": "IncomingCallUI.module__header___MmU1X3",
  "nr": "IncomingCallUI.module__headerIcon___MmU1X3",
  "my": "IncomingCallUI.module__avatar___MmU1X3",
  "_0": "IncomingCallUI.module__ic-ring-pulse___MmU1X3",
  "sI": "IncomingCallUI.module__callerInfo___MmU1X3",
  "XF": "IncomingCallUI.module__callerName___MmU1X3",
  "_n": "IncomingCallUI.module__callerSubtitle___MmU1X3",
  "o1": "IncomingCallUI.module__actions___MmU1X3",
  "mH": "IncomingCallUI.module__actionGroup___MmU1X3",
  "T$": "IncomingCallUI.module__circleButton___MmU1X3",
  "FM": "IncomingCallUI.module__circleButtonAccept___MmU1X3",
  "cK": "IncomingCallUI.module__circleButtonReject___MmU1X3",
  "V6": "IncomingCallUI.module__circleButtonIconRotated___MmU1X3",
  "ZJ": "IncomingCallUI.module__actionLabel___MmU1X3",
  "rw": "IncomingCallUI.module__ignoreLink___MmU1X3",
  "IR": "IncomingCallUI.module__screenReaderOnly___MmU1X3",
  "Po": "IncomingCallUI.module__bottomSheetStack___MmU1X3",
};

module.exports = exports;
